"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clones__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var Clones__factory_1 = require("./Clones__factory");
Object.defineProperty(exports, "Clones__factory", { enumerable: true, get: function () { return Clones__factory_1.Clones__factory; } });
